import Button from "../Button/Button";
import { ProductCards } from "../ProductCards/ProductCards";
import { useTranslation } from "react-i18next";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useUID } from "../../context/UIDContext";
import "./styles.css";
import { useConfig } from "../../context/ConfigContext";

export const ProductCart = ({ recommendedProducts, onProductSelect }) => {
  const { t } = useTranslation("recommendation");
  const { isNLUser } = useConfig();
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  const selectedProducts = recommendedProducts.filter((item) => {
    return item.price !== undefined && item.price !== "" && item.selected;
  });

  const productCartQuery = selectedProducts
    .map((item) => `${item.size}:1`)
    .join(",");

  const shopLink = isNLUser
    ? "https://rosental-organics.nl/cart/"
    : "https://rosental.de/cart/";

  return (
    <div className="checkout-products">
      <div className="checkout-page_header">
        <h4 className="checkout-page-info">{t("title-checkout-cart")}</h4>
      </div>

      {/* Products */}
      <div className="checkout-products-content">
        <ProductCards
          layout="list"
          products={selectedProducts}
          onProductSelect={(productId) => {
            const updatedData = recommendedProducts.map((product) =>
              product.id === productId
                ? { ...product, selected: !product.selected }
                : product,
            );
            onProductSelect(updatedData);
          }}
        />
      </div>

      <div className="checkout-button-wrapper">
        <Button
          text={t("to-checkout")}
          onClick={() => {
            trackEvent("webapp_user_clicked_checkout", uid);
            const newWindow = window.open(
              `${shopLink}${productCartQuery}`,
              "_blank",
              "noopener,noreferrer",
            );
            if (newWindow) newWindow.opener = null;
          }}
          disabled={selectedProducts.length < 1}
        />
      </div>
    </div>
  );
};
